import V from 'voUtils/V.js';

import {
	isBlank,
	objectIsSimilar
}
from 'voUtils/tools.js';

import {
	fireSearch
}
from 'voUtils/TagEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	getVoucher
}
from 'voUtils/VoucherStore.js';
import {
	getAbTest
}
from 'voUtils/AbTest.js';

import {
	getFavIds
}
from 'voUtils/FavStore.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';


export default {
	data: {
		mapItems: [{
			"_id": 1,
			"sectionid": "cameo",
			"name": "Cameo - Drinks",
			"loc": {
				"coordinates": [9.933959341104421, 54.66048711473549]
			}
		}, {
			"_id": 2,
			"sectionid": "fahrschanke",
			"name": "Fährschänke - Drinks",
			"loc": {
				"coordinates": [9.934097999999999, 54.660655338978714]
			}
		}, {
			"_id": 3,
			"sectionid": "palette",
			"name": "Palette - Drinks",
			"loc": {
				"coordinates": [9.933468968092267, 54.66099895105194]
			}
		}, {
			"_id": 4,
			"sectionid": "hammaburg",
			"name": "Hammaburg - Drinks",
			"loc": {
				"coordinates": [10.023661446014088, 54.58324857243044]
			}
		}, {
			"_id": 5,
			"sectionid": "mobydick",
			"name": "Moby Dick - Drinks",
			"loc": {
				"coordinates": [10.023122895485912, 54.58397352160486]
			}
		}, {
			"_id": 6,
			"sectionid": "clarahofdestillerie",
			"name": "Clara Hof Destillerie - Drinks",
			"loc": {
				"coordinates": [9.836821341104418, 54.47424898755892]
			}
		}, {
			"_id": 7,
			"sectionid": "landinsicht",
			"name": "Land in Sicht - Drinks",
			"loc": {
				"coordinates": [9.83998931779116, 54.468270378420236]
			}
		}, {
			"_id": 8,
			"sectionid": "romerandwein",
			"name": "Römer & Wein - Drinks",
			"loc": {
				"coordinates": [9.836286670552209, 54.47411459794681]
			}
		}, {
			"_id": 9,
			"sectionid": "flensburgerbrauerei",
			"name": "Flensburger Brauerei - Drinks",
			"loc": {
				"coordinates": [9.43360330613453, 54.77782054143194]
			}
		}, {
			"_id": 10,
			"sectionid": "dieweinstubeinkrusehof",
			"name": "Die Weinstube im Krusehof - Drinks",
			"loc": {
				"coordinates": [9.43565732944779, 54.7815065407447]
			}
		}, {
			"_id": 11,
			"sectionid": "weinundrumhausbraasch",
			"name": "Wein- und Rumhaus Braasch - Drinks",
			"loc": {
				"coordinates": [9.435744317791158, 54.78144754075569]
			}
		}, {
			"_id": 12,
			"sectionid": "lille",
			"name": "lille - Drinks",
			"loc": {
				"coordinates": [10.110693242911067, 54.33247075212187]
			}
		}, {
			"_id": 13,
			"sectionid": "mumdad",
			"name": "MUM&DAD - Drinks",
			"loc": {
				"coordinates": [10.131944670552212, 54.319176191146965]
			}
		}, {
			"_id": 14,
			"sectionid": "seebar",
			"name": "Seebar - Drinks",
			"loc": {
				"coordinates": [10.15324597668674, 54.34664118501023]
			}
		}, {
			"_id": 15,
			"sectionid": "dolleruperdestille",
			"name": "Dolleruper Destille - Drinks",
			"loc": {
				"coordinates": [9.675486958905797, 54.78198713192971]
			}
		}, {
			"_id": 16,
			"sectionid": "hafencafemarinahulsen",
			"name": "Hafencafé Marina Hülsen - Drinks",
			"loc": {
				"coordinates": [9.750259682208839, 54.54602830725556]
			}
		}],
	},
	beforeMount: function () {

	},
	updated: function () {

	},
	computed: {

	},
	watch: {

	}

};